import { Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, VStack } from '@chakra-ui/react';
import NavButton from '../NavButton';

export interface MobileNavigationProps {
    isOpen: boolean;
    onClose: () => void;
};

const MobileNavigation = (props: MobileNavigationProps) => {
    return (
        <Drawer
            isOpen={props.isOpen}
            placement='right'
            onClose={props.onClose}
            size='full'
        >
            <DrawerOverlay />
            <DrawerContent 
                bg='brand.black' 
                color='brand.white'
            >
                <DrawerCloseButton size='lg' />
                <DrawerHeader>VIRTUE AEROSPACE</DrawerHeader>

                <DrawerBody 
                    flex='1'
                    padding='unset'
                >
                    <VStack flex='1' flexDir='column'>
                        <NavButton isMobile={true} to='/'>
                            HOME
                        </NavButton>
                        <NavButton isMobile={true} to='/summary'>
                            SUMMARY
                        </NavButton>
                        <NavButton isMobile={true} to='/documents'>
                            DOCUMENTS
                        </NavButton>
                        <NavButton isMobile={true} to='/plantlist'>
                            PLANT LIST
                        </NavButton>
                        <NavButton isMobile={true} to='/contact'>
                            CONTACT
                        </NavButton>
                    </VStack>
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    );
};

export default MobileNavigation;